__turbopack_context__.v({
  "body": "WBlogPopularPosts-module__3VHqEa__body",
  "card": "WBlogPopularPosts-module__3VHqEa__card",
  "empty": "WBlogPopularPosts-module__3VHqEa__empty",
  "heading": "WBlogPopularPosts-module__3VHqEa__heading",
  "inner": "WBlogPopularPosts-module__3VHqEa__inner",
  "item": "WBlogPopularPosts-module__3VHqEa__item",
  "list": "WBlogPopularPosts-module__3VHqEa__list",
  "readMore": "WBlogPopularPosts-module__3VHqEa__readMore",
  "root": "WBlogPopularPosts-module__3VHqEa__root",
  "thumb": "WBlogPopularPosts-module__3VHqEa__thumb",
  "title": "WBlogPopularPosts-module__3VHqEa__title",
});
